var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPontoEstrategicoIcone = function SvgPontoEstrategicoIcone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3007 0.277049C10.6518 -0.179142 9.75599 -0.0229393 9.2998 0.625938C9.04095 0.99412 9.11071 1.49482 9.44832 1.77961L5.92193 6.79548L5.57888 6.5543C5.05978 6.18935 4.34311 6.31431 3.97816 6.83341C3.61321 7.35251 3.73817 8.06918 4.25727 8.43413L6.98207 10.3498L1.11709 18.692C0.868461 19.0457 0.953592 19.5339 1.30723 19.7825C1.66087 20.0312 2.1491 19.946 2.39772 19.5924L8.26271 11.2501L11.3419 13.415C11.861 13.7799 12.5777 13.655 12.9426 13.1359C13.3076 12.6168 13.1826 11.9001 12.6635 11.5351L12.3251 11.2972L15.8518 6.28102C16.2335 6.4993 16.7257 6.39494 16.9836 6.02803C17.4398 5.37916 17.2836 4.48332 16.6347 4.02713L11.3007 0.277049Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPontoEstrategicoIcone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ponto-estrategico-icone.93dca301.svg";
export { ForwardRef as ReactComponent };